import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import VerifiedBadge from './VerifiedBadge'

const CATEGORY_LABELS = {
  photographer:'Photographer', videographer:'Videographer', decorator:'Decorator',
  mc_dj:'MC / DJ', caterer:'Caterer', aso_ebi:'Aso Ebi', makeup:'Makeup Artist',
  bridal_fashion:'Bridal Fashion', venue:'Venue', live_band:'Live Band',
  cake:'Cake Designer', planner:'Event Planner',
}
const fmtPrice = (n, cur='NGN') =>
  n ? `${cur==='NGN'?'₦':cur+' '}${Number(n).toLocaleString()}` : null

const Pill = ({ children }) => (
  <span style={{ background:'rgba(255,255,255,0.18)', backdropFilter:'blur(4px)',
    border:'1px solid rgba(255,255,255,0.3)', borderRadius:100, padding:'0.15rem 0.6rem',
    fontFamily:'Nunito Sans, sans-serif', fontSize:'0.66rem', fontWeight:600, color:'#fff',
    whiteSpace:'nowrap' }}>{children}</span>
)

/**
 * VendorCard — SQUARE card (rounded). Shows the cover image by default; on hover
 * it reveals a 2×2 grid of the vendor's images (the main image included).
 * Verified badge + name/pills overlaid. Click → vendor profile.
 */
export default function VendorCard({ vendor }) {
  const navigate = useNavigate()
  const [hover, setHover] = useState(false)
  const gallery = Array.isArray(vendor.gallery_images) ? vendor.gallery_images : []
  const cover = gallery[0] || vendor.profile_image_url
  const price = fmtPrice(vendor.starting_price, vendor.price_currency)
  // four cells for the hover grid (pad with cover if fewer than 4 images)
  const grid = [0, 1, 2, 3].map(i => gallery[i] || cover)
  const canGrid = gallery.length > 1

  return (
    <button
      onClick={() => navigate(`/dashboard/aisle/vendor/${vendor.id}`)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ position:'relative', display:'block', width:'100%', textAlign:'left',
        border:'none', padding:0, cursor:'pointer', borderRadius:'1rem', overflow:'hidden',
        aspectRatio:'1/1', background:'#E5E0D8', boxShadow:'0 6px 22px rgba(0,0,0,0.10)' }}
    >
      {/* Image layer: single cover, or a 2×2 grid on hover */}
      {hover && canGrid ? (
        <div style={{ position:'absolute', inset:0, display:'grid',
          gridTemplateColumns:'1fr 1fr', gridTemplateRows:'1fr 1fr', gap:2, background:'#fff' }}>
          {grid.map((src, i) => (
            <img key={i} src={src} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
          ))}
        </div>
      ) : (
        cover && <img src={cover} alt={vendor.business_name} loading="lazy"
          style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' }} />
      )}

      {/* dark gradient for legibility */}
      <div style={{ position:'absolute', inset:0, pointerEvents:'none',
        background:'linear-gradient(to top, rgba(26,26,26,0.80) 0%, rgba(26,26,26,0.15) 48%, rgba(26,26,26,0) 72%)' }} />

      {/* verified badge top-left */}
      <div style={{ position:'absolute', top:10, left:10 }}>
        <VerifiedBadge status={vendor.verification_status || 'verified'} size={18} />
      </div>

      {/* featured tag (Pro tier) top-right */}
      {vendor.membership_tier === 'pro' && (
        <div style={{ position:'absolute', top:10, right:10, background:'#C4826A', color:'#fff',
          fontFamily:'Nunito Sans, sans-serif', fontSize:'0.6rem', fontWeight:700, letterSpacing:'0.05em',
          borderRadius:100, padding:'2px 8px' }}>★ FEATURED</div>
      )}

      {/* details */}
      <div style={{ position:'absolute', left:0, right:0, bottom:0, padding:'0.9rem' }}>
        <h3 style={{ fontFamily:'Gibs, serif', fontWeight:600, fontSize:'1.05rem',
          color:'#fff', margin:'0 0 0.45rem', lineHeight:1.2,
          textShadow:'0 1px 8px rgba(0,0,0,0.4)' }}>{vendor.business_name}</h3>
        <div style={{ display:'flex', flexWrap:'wrap', gap:'0.35rem' }}>
          <Pill>{CATEGORY_LABELS[vendor.category] || vendor.category}</Pill>
          {vendor.city && <Pill>{vendor.city}</Pill>}
          {price && <Pill>from {price}</Pill>}
        </div>
      </div>
    </button>
  )
}
